// Selectable chip — friend pickers, filters, tag selects. 40px min touch target.
// `on` fills with brand tint. Also a Segmented control built from the same tokens.
export function Pill({ on = false, onClick, className = "", children, ...rest }) {
  return (
    <button type="button" onClick={onClick} className={`bz-pill${on ? " bz-pill--on" : ""} ${className}`.trim()} {...rest}>
      {children}
    </button>
  );
}

// Segmented control: options = [{value, label}], value = active value.
// `disabled` uzamkne celý prepínač (napr. Zapisovanie výzvy po vytvorení — režim je nemenný).
export function Segmented({ options = [], value, onChange, className = "", style, disabled = false }) {
  return (
    <div className={`bz-seg${disabled ? " bz-seg--disabled" : ""} ${className}`.trim()} style={style} role="tablist">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="tab"
          disabled={disabled}
          aria-selected={value === o.value}
          onClick={() => onChange && onChange(o.value)}
          className={`bz-seg__btn${value === o.value ? " bz-seg__btn--on" : ""}`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
